"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichResultsWithAssociations = void 0;
var core_1 = require("@newfront-insurance/core");
var dod_api_1 = require("@newfront-insurance/dod-api");
function enrichResultsWithAssociations(searchResults, associationsMap) {
    return searchResults.map(function (result) {
        var _a, _b;
        var types = (_a = result.objectReferenceTypes) !== null && _a !== void 0 ? _a : [];
        var ids = (_b = result.objectReferenceIds) !== null && _b !== void 0 ? _b : [];
        var associations = types
            .map(function (type, i) { return associationsMap.get((0, dod_api_1.hashDomainObjectIndex)({ type: type, id: ids[i] })); })
            .filter(core_1.isNotNil);
        return __assign(__assign({}, result), { associations: associations });
    });
}
exports.enrichResultsWithAssociations = enrichResultsWithAssociations;
